'use strict';

function _createDestroy(extendDestroy, extensionDestroy) {
    return function () {
        extendDestroy();
        extensionDestroy();
    };
}

module.exports = function () {
	if (!arguments.length) {
		return;
	}

	var extended = arguments[0]; // eslint-disable-line prefer-rest-params

	for (var i = 1; i < arguments.length; i++) {
		var extension = arguments[i]; // eslint-disable-line prefer-rest-params

		if (!extension) {
			continue;
		}

		for (var name in extension) {
            if (Object.prototype.hasOwnProperty.call(extension, name)) {
				var extendedProperty = extended[name];
				var extensionProperty = extension[name];

				if (name === 'destroy' && typeof extendedProperty === 'function' && typeof extensionProperty === 'function') {
					extended.destroy = _createDestroy(extensionProperty.bind(extension), extendedProperty.bind(extended));
				} else if (extensionProperty !== undefined && extendedProperty !== extensionProperty) {
					extended[name] = extensionProperty;
				}
			}

		}
	}

	return extended;
};



// WEBPACK FOOTER //
// ./src/js/util/extend.js